export default __webpack_public_path__ + "static/media/platform_admin.5293c406.svg";